import React from "react";
import { cn } from "@/lib/utils";

type BrandCardProps = React.HTMLAttributes<HTMLDivElement>;

export const BrandCard: React.FC<BrandCardProps> = ({ className, children, ...rest }) => {
  return (
    <div
      className={cn(
        "rounded-[24px] border border-ink/[0.07] bg-cvcard p-5 shadow-[0_2px_10px_-2px_rgba(24,25,19,0.08)]",
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
